module.exports = __webpack_public_path__ + "img/handsup-logo.119b1471.svg";